import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import SecuritySystemInputComponent from './SecuritySystemsInputComponent';

interface Props {
  question: FlowsQuestion;
}

const SecuritySystemInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <SecuritySystemInputComponent question={question} />;
  }
};

export default SecuritySystemInputPicker;
